var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom-menu"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col col--left text size-large"},[_c('nav',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.$store.dispatch('scrollToTop')}}},[_vm._v("Return "),_c('br'),_vm._v("to top")])])]),_vm._v(" "),_c('div',{staticClass:"col text nav size-large"},[_c('nav-items',{attrs:{"position":"bottom"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2043bbb2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bottom-menu.vue
// module id = 240
// module chunks = 1